export default __webpack_public_path__ + "assets/images/roadmap-rocket.d937d34a.png";